import React from 'react';
import { MagnifyingGlass } from 'phosphor-react';
import { useTranslation } from 'react-i18next';
import * as S from '../styles';

interface EmptyStateProps {
  query: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ query }) => {
  const { t } = useTranslation();

  return (
    <S.EmptyStateContainer>
      <MagnifyingGlass size={48} weight="thin" />
      <S.EmptyStateTitle>{query ? t('No results found') : t('No partners available')}</S.EmptyStateTitle>
      {query && <S.EmptyStateText>{t('Try adjusting your search terms')}</S.EmptyStateText>}
    </S.EmptyStateContainer>
  );
};
